/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Insufficientinformation3Inputs */

const en_coinvestments_declinedeal_reasons_insufficientinformation3 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Insufficientinformation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insufficient information to proceed`)
};

/**
* | output |
* | --- |
* | "Insufficient information to proceed" |
*
* @param {Coinvestments_Declinedeal_Reasons_Insufficientinformation3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_insufficientinformation3 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Insufficientinformation3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Insufficientinformation3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_insufficientinformation3(inputs)
});
export { coinvestments_declinedeal_reasons_insufficientinformation3 as "coInvestments_declineDeal_reasons_insufficientInformation" }